import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { Checkbox } from '@openng/optimus-ui/checkbox';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface CheckboxProps extends FieldWrapperProps {
  text?: string;
  textClass?: string;
  binary?: boolean;

  containerClass?: string;
}

export interface CheckboxFieldConfig extends FormlyFieldConfig<CheckboxProps> {
  type?: 'checkbox' | Type<CheckboxTypeComponent>;
}

@Component({
  selector: 'lib-formly-checkbox-type',
  templateUrl: './checkbox-type.component.html',
  styleUrl: './checkbox-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, Checkbox, ReactiveFormsModule, FormlyModule, TranslocoDirective]
})
export class CheckboxTypeComponent extends FieldType<FieldTypeConfig<CheckboxProps>> {}
